import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaHome, FaShoppingCart, FaWhatsapp, FaFacebookF, FaInstagram, FaTiktok } from 'react-icons/fa';
import backgroundImage from '../assets/navbar/pngtree-closeup-top-view-of-cinnamon-powder-texture-on-ground-cinnamon-bark-image_13721250.png';

const Footer = () => {
    return (
        <footer
            className="py-4"
            style={{
                background: `linear-gradient(rgba(255, 255, 255, 0.85), rgba(255, 255, 255, 0.85)), url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: '#355E3B',
                marginTop: 'clamp(1rem, 5vw, 2rem)',
                borderTopLeftRadius: '15px',
                borderTopRightRadius: '15px',
                boxShadow: '0 -5px 15px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.3s ease-in-out',
                backdropFilter: 'blur(2px)'
            }}
        >
            <Container>
                <Row className="text-center text-md-start g-4">
                    {/* Contact Section */}
                    <Col xs={12} md={6} lg={3} className="mb-3 border-top border-2 border-secondary pt-3">
                        <h4
                            style={{
                                fontFamily: 'Georgia',
                                color: '#C19A6B',
                                fontWeight: 'bold',
                                fontSize: 'clamp(1.2rem, 3vw, 1.5rem)'
                            }}
                        >
                            Contact Us
                        </h4>
                        <p
                            style={{
                                fontFamily: 'Georgia',
                                color: '#355E3B',
                                fontSize: 'clamp(0.85rem, 2vw, 1rem)'
                            }}
                        >
                            <FaEnvelope className="me-2" style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }} />
                            <a
                                href="mailto:info@redevsolutions.com"
                                style={{ color: '#355E3B', textDecoration: 'none' }}
                                aria-label="Email us at info@redevsolutions.com"
                            >
                                Email: info@redevsolutions.com
                            </a>
                        </p>
                        <p
                            style={{
                                fontFamily: 'Georgia',
                                color: '#355E3B',
                                fontSize: 'clamp(0.85rem, 2vw, 1rem)'
                            }}
                        >
                            <FaPhone className="me-2" style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }} />
                            <a
                                href="tel:+94779291829"
                                style={{ color: '#355E3B', textDecoration: 'none' }}
                                aria-label="Call us at +94 77 929 1829"
                            >
                                Phone: +94 77 929 1829
                            </a>
                        </p>
                        <p
                            style={{
                                fontFamily: 'Georgia',
                                color: '#355E3B',
                                fontSize: 'clamp(0.85rem, 2vw, 1rem)'
                            }}
                        >
                            <FaMapMarkerAlt className="me-2" style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }} />
                            <a
                                href="https://maps.google.com/?q=448/2,+Nawadagala,+Elpitiya,+Sri+Lanka"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#355E3B', textDecoration: 'none' }}
                                aria-label="View our location at 448/2, Nawadagala, Elpitiya on Google Maps"
                            >
                                448/2, near the school, Nawadagala, Elpitiya
                            </a>
                        </p>
                    </Col>

                    {/* Quick Links Section */}
                    <Col xs={12} md={6} lg={3} className="mb-3 border-top border-2 border-secondary pt-3">
                        <h4
                            style={{
                                fontFamily: 'Georgia',
                                color: '#C19A6B',
                                fontWeight: 'bold',
                                fontSize: 'clamp(1.2rem, 3vw, 1.5rem)'
                            }}
                        >
                            Quick Links
                        </h4>
                        <ul className="list-unstyled">
                            <li
                                style={{
                                    fontFamily: 'Georgia',
                                    color: '#355E3B',
                                    fontSize: 'clamp(0.85rem, 2vw, 1rem)',
                                    marginBottom: '0.5rem'
                                }}
                            >
                                <a
                                    href="/"
                                    className="footer-link"
                                    aria-label="Go to Home page"
                                >
                                    <FaHome className="me-2" style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }} /> Home
                                </a>
                            </li>
                            <li
                                style={{
                                    fontFamily: 'Georgia',
                                    color: '#355E3B',
                                    fontSize: 'clamp(0.85rem, 2vw, 1rem)',
                                    marginBottom: '0.5rem'
                                }}
                            >
                                <a
                                    href="/shop"
                                    className="footer-link"
                                    aria-label="Go to Shop page"
                                >
                                    <FaShoppingCart className="me-2" style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }} /> Shop
                                </a>
                            </li>
                            <li
                                style={{
                                    fontFamily: 'Georgia',
                                    color: '#355E3B',
                                    fontSize: 'clamp(0.85rem, 2vw, 1rem)',
                                    marginBottom: '0.5rem'
                                }}
                            >
                                <a
                                    href="/cart"
                                    className="footer-link"
                                    aria-label="Go to Cart page"
                                >
                                    <FaShoppingCart className="me-2" style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }} /> Cart
                                </a>
                            </li>
                        </ul>
                    </Col>

                    {/* Cinnamon Products Section */}
                    <Col xs={12} md={6} lg={3} className="mb-3 border-top border-2 border-secondary pt-3">
                        <h4
                            style={{
                                fontFamily: 'Georgia',
                                color: '#C19A6B',
                                fontWeight: 'bold',
                                fontSize: 'clamp(1.2rem, 3vw, 1.5rem)'
                            }}
                        >
                            Cinnamon Products
                        </h4>
                        <p
                            style={{
                                fontFamily: 'Georgia',
                                color: '#355E3B',
                                fontSize: 'clamp(0.85rem, 2vw, 1rem)',
                                lineHeight: '1.5'
                            }}
                        >
                            Discover the finest Ceylon Cinnamon, known for its sweet, warm flavor and medicinal benefits. Explore our range of sticks, powders, and oils.
                        </p>
                        <a
                            href="/shop#cinnamon"
                            className="footer-link"
                            style={{ fontFamily: 'Georgia', color: '#C19A6B', textDecoration: 'underline', fontSize: 'clamp(0.85rem, 2vw, 1rem)' }}
                            aria-label="Shop cinnamon products"
                        >
                            Shop Cinnamon Now
                        </a>
                    </Col>

                    {/* Social Media Section */}
                    <Col xs={12} md={6} lg={3} className="border-top border-2 border-secondary pt-3">
                        <h4
                            style={{
                                fontFamily: 'Georgia',
                                color: '#C19A6B',
                                fontWeight: 'bold',
                                fontSize: 'clamp(1.2rem, 3vw, 1.5rem)'
                            }}
                        >
                            Follow Us
                        </h4>
                        <div className="d-flex justify-content-center justify-content-md-start gap-3">
                            <a
                                href="https://wa.me/+94779291829"
                                target="_blank"
                                rel="noopener noreferrer nofollow"
                                className="social-link"
                                aria-label="Contact us on WhatsApp"
                            >
                                <FaWhatsapp />
                            </a>
                            <a
                                href="https://facebook.com/galleceylonspices"
                                target="_blank"
                                rel="noopener noreferrer nofollow"
                                className="social-link"
                                aria-label="Visit our Facebook page"
                            >
                                <FaFacebookF />
                            </a>
                            <a
                                href="https://instagram.com/galleceylonspices"
                                target="_blank"
                                rel="noopener noreferrer nofollow"
                                className="social-link"
                                aria-label="Visit our Instagram page"
                            >
                                <FaInstagram />
                            </a>
                            <a
                                href="https://tiktok.com/@galleceylonspices"
                                target="_blank"
                                rel="noopener noreferrer nofollow"
                                className="social-link"
                                aria-label="Visit our TikTok page"
                            >
                                <FaTiktok />
                            </a>
                        </div>
                    </Col>
                </Row>
                <Row className="mt-4 text-center">
                    <Col>
                        <p
                            style={{
                                fontFamily: 'Georgia',
                                color: '#355E3B',
                                fontSize: 'clamp(0.85rem, 2vw, 1rem)',
                                marginBottom: '0'
                            }}
                        >
                            © {new Date().getFullYear()} <span style={{ color: '#C19A6B', fontWeight: 'bold' }}>Galle Ceylon Spices International (Pvt) Ltd</span> | Developed by <a href="https://redevsolutions.com" style={{ color: '#C19A6B', fontWeight: 'bold', textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">Redev Solutions</a>
                        </p>
                    </Col>
                </Row>
            </Container>

            {/* Inline CSS for styling and responsiveness */}
            <style>
                {`
                    .footer-link {
                        color: #355E3B;
                        text-decoration: none;
                        transition: color 0.3s ease, transform 0.3s ease;
                        display: inline-flex;
                        align-items: center;
                    }
                    .footer-link:hover, .footer-link:focus {
                        color: #A67B4D !important;
                        transform: scale(1.05);
                    }
                    .social-link {
                        color: #C19A6B;
                        font-size: clamp(1.2rem, 3vw, 1.8rem);
                        transition: color 0.3s ease, transform 0.3s ease;
                    }
                    .social-link:hover, .social-link:focus {
                        color: #A67B4D !important;
                        transform: scale(1.2);
                    }
                    footer {
                        position: relative;
                        z-index: 1;
                    }
                    @media (max-width: 576px) {
                        footer {
                            padding: 1.5rem 0 !important;
                            margin-top: 1rem !important;
                        }
                        .py-4 {
                            padding-top: 1rem !important;
                            padding-bottom: 1rem !important;
                        }
                        .g-4 {
                            row-gap: 1rem !important;
                        }
                        .border-top {
                            border-top-width: 1px !important;
                        }
                        h4 {
                            font-size: clamp(1rem, 2.5vw, 1.2rem) !important;
                        }
                        p, a, li {
                            font-size: clamp(0.8rem, 1.8vw, 0.9rem) !important;
                        }
                        .social-link {
                            font-size: clamp(1rem, 2.5vw, 1.4rem) !important;
                        }
                    }
                    @media (max-width: 576px) and (orientation: landscape) {
                        footer {
                            padding: 1rem 0 !important;
                        }
                        .py-4 {
                            padding-top: 0.75rem !important;
                            padding-bottom: 0.75rem !important;
                        }
                        .g-4 {
                            row-gap: 0.75rem !important;
                        }
                        h4 {
                            font-size: clamp(0.9rem, 2vw, 1.1rem) !important;
                        }
                        p, a, li {
                            font-size: clamp(0.75rem, 1.5vw, 0.85rem) !important;
                        }
                        .social-link {
                            font-size: clamp(0.9rem, 2vw, 1.2rem) !important;
                        }
                    }
                    @media (min-width: 577px) and (max-width: 768px) {
                        footer {
                            padding: 2rem 0 !important;
                            margin-top: 1.5rem !important;
                        }
                        .py-4 {
                            padding-top: 1.5rem !important;
                            padding-bottom: 1.5rem !important;
                        }
                        .g-4 {
                            row-gap: 1.5rem !important;
                        }
                        h4 {
                            font-size: clamp(1.1rem, 2.5vw, 1.3rem) !important;
                        }
                        p, a, li {
                            font-size: clamp(0.8rem, 1.8vw, 0.95rem) !important;
                        }
                    }
                    @media (min-width: 769px) and (max-width: 1024px) {
                        footer {
                            padding: 2.5rem 0 !important;
                            margin-top: 1.75rem !important;
                        }
                        .py-4 {
                            padding-top: 2rem !important;
                            padding-bottom: 2rem !important;
                        }
                        .g-4 {
                            row-gap: 2rem !important;
                        }
                    }
                    @media (min-width: 1025px) {
                        footer {
                            padding: 3rem 0 !important;
                            margin-top: 2rem !important;
                        }
                        .py-4 {
                            padding-top: 2.5rem !important;
                            padding-bottom: 2.5rem !important;
                        }
                    }
                `}
            </style>
        </footer>
    );
};

export default Footer;